import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import AddEuroDocumentForm from "../../components/pageManager/AddEuroDocumentForm";

const AddEuroDocumentFormPage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <AddEuroDocumentForm />
                </div>
            </div>
        </div>
    );
};

export default AddEuroDocumentFormPage;
